import { Injectable } from "@angular/core";
import { LinhaRota } from "@tivic-team/manager-ts/dist/mob/entities/linha/linha-rota.entity";
import { LinhaTrecho } from "@tivic-team/manager-ts/dist/mob/entities/linha/linha-trecho.entity";
import { LinhaTrechoDTO } from "app/model/dtos/mob/linha-trecho.dto";
import { HttpDelete, HttpGet, HttpPost, HttpPut, HttpResponse, JSONData, Quark, Url } from "sol-request-angular/dist/comunicacao";
import { IFilter } from "sol-request-angular/dist/comunicacao/interfaces/IFilter";
import { environmentv3 } from "src/environments/environmentv3";
import { ApiController } from "../api-controller.interface";

@Injectable()
export class LinhaTrechoController implements ApiController<LinhaTrechoDTO> {
  constructor() {}

  async create(linhaTrechoDTO: LinhaTrechoDTO): Promise<LinhaTrechoDTO> {
    let quark = new Quark(
      new HttpPost({
        url: new Url({
          id: "mob/linhatrecho",
          environment: environmentv3,
        }),
        data: new JSONData(linhaTrechoDTO),
      }),
      new HttpResponse(new LinhaRota())
    );
    return await quark.call();
  }

  async createLinhaTrechoColetivoRural(linhaTrechoDTO: LinhaTrechoDTO): Promise<LinhaTrechoDTO> {
    let quark = new Quark(
      new HttpPost({
        url: new Url({
          id: "mob/linhatrecho/coletivo-rural",
          environment: environmentv3,
        }),
        data: new JSONData(linhaTrechoDTO),
      }),
      new HttpResponse(new LinhaTrechoDTO())
    );
    return await quark.call();
  }

  async update(linhaTrechoDTO: LinhaTrechoDTO): Promise<LinhaTrechoDTO> {
    let quark = new Quark(
      new HttpPut({
        url: new Url({
            id: "mob/linhatrecho/:cdLinha/:cdRota",
            environment: environmentv3,
            pathParams: new JSONData({
                cdLinha: linhaTrechoDTO.cdLinha,
                cdRota: linhaTrechoDTO.cdRota,
                cdTrecho: linhaTrechoDTO.cdTrecho
            }),
        }),
        data: new JSONData(linhaTrechoDTO),
      }),
      new HttpResponse(new LinhaTrechoDTO())
    );
    return await quark.call();
  }

  async updateLinhaTrechoColetivoRural(linhaTrechoDTO: LinhaTrechoDTO): Promise<LinhaTrechoDTO> {
    let quark = new Quark(
      new HttpPut({
        url: new Url({
            id: "mob/linhatrecho/coletivo-rural/:cdLinha/:cdRota",
            environment: environmentv3,
            pathParams: new JSONData({
                cdLinha: linhaTrechoDTO.cdLinha,
                cdRota: linhaTrechoDTO.cdRota,
                cdTrecho: linhaTrechoDTO.cdTrecho
            }),
        }),
        data: new JSONData(linhaTrechoDTO),
      }),
      new HttpResponse(new LinhaTrechoDTO())
    );
    return await quark.call();
  }

  async ordernar(itinerarios: LinhaTrechoDTO[]): Promise<LinhaTrechoDTO[]> {
    let quark = new Quark(
      new HttpPut({
        url: new Url({
            id: "mob/linhatrecho/itinerarios",
            environment: environmentv3,
        }),
        data: new JSONData(itinerarios)
      }),
      new HttpResponse(new Array<LinhaTrechoDTO>())
    );
    return await quark.call();
  }

  find(filters?: IFilter): Promise<Array<LinhaTrechoDTO>> {
    let request = new Quark(
      new HttpGet({
        url: new Url({
            id: "mob/linhatrecho/itinerarios",
            environment: environmentv3,
            filter: filters,
        }),
      }),
      new HttpResponse(Array<LinhaTrechoDTO>())
    );
    return request.call();
  }

  findTrechos(filters?: IFilter): Promise<Array<LinhaTrechoDTO>> {
    let request = new Quark(
      new HttpGet({
        url: new Url({
            id: "mob/linhatrecho/trechos",
            environment: environmentv3,
            filter: filters,
        }),
      }),
      new HttpResponse(Array<LinhaTrechoDTO>())
    );
    return request.call();
  }


  findIntinerarios(filters?: IFilter): Promise<Array<LinhaTrechoDTO>> {
    let request = new Quark(
      new HttpGet({
        url: new Url({
            id: "mob/linhatrecho/coletivo-rural/itinerarios/",
            environment: environmentv3,
            filter: filters,
        }),
      }),
      new HttpResponse(Array<LinhaTrechoDTO>())
    );
    return request.call();
  }

  async remove(cdLinha: number, cdRota: number, cdTrecho: number): Promise<LinhaTrecho> {
    let quark = new Quark(
      new HttpDelete({
        url: new Url({
            id: "mob/linhatrecho/:cdLinha/:cdRota/:cdTrecho",
            environment: environmentv3,
            pathParams: new JSONData({ cdLinha, cdRota, cdTrecho }),
        }),
      }),
      new HttpResponse(new LinhaTrecho())
    );
    return await quark.call();
  }

  async removeTrechoColetivoRural(cdLinha: number, cdRota: number, cdTrecho: number): Promise<LinhaTrecho> {
    let quark = new Quark(
      new HttpDelete({
        url: new Url({
            id: "mob/linhatrecho/coletivo-rural/:cdLinha/:cdRota/:cdTrecho",
            environment: environmentv3,
            pathParams: new JSONData({ cdLinha, cdRota, cdTrecho }),
        }),
      }),
      new HttpResponse(new LinhaTrecho())
    );
    return await quark.call();
  }

  get(id: number): Promise<LinhaTrechoDTO> {
    throw new Error("Method not implemented.");
  }

  
}
